module.exports = __webpack_public_path__ + "img/SOF2019-2020annualreport.fd073356.jpg";